import { createContext, useContext } from 'react'
import { type ConsentChoice } from './posthog'

export type ConsentState = {
  choice: ConsentChoice | null
  setChoice: (c: ConsentChoice) => void
  resetChoice: () => void
}

export const ConsentContext = createContext<ConsentState | null>(null)

export function useConsent() {
  const ctx = useContext(ConsentContext)
  if (!ctx) throw new Error('useConsent must be used inside ConsentProvider')
  return ctx
}
